import moment from "moment";
import React from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import ContractorRecordsLink from "../ContractorRecordsLink";
import {
  REGISTRATIONS,
  registrationExpiry,
  registrationStatus,
} from "../recordKinds";
import { tidyCountry } from "Components/Common/CountrySelect";

/** Flags a registration that has lapsed or lapses within 90 days. */
const RegistrationStatus = ({ registration }: { registration: any }) => {
  const status = registrationStatus(
    registrationExpiry(registration?.registrationDate, registration?.lengthOfValidity)
  );
  return status ? (
    <span className={`badge bg-${status.tone}-subtle text-ink-${status.tone} ms-2`}>
      {status.label}
    </span>
  ) : null;
};

const ContractorRegistration = ({ contractor }: { contractor: any }) => {

  return (
    <Card>
      <CardHeader className="d-flex align-items-center border-bottom-dashed">
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">
            Contractor Registration
          </h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <ContractorRecordsLink contractor={contractor} config={REGISTRATIONS} />
        </div>
      </CardHeader>
      <CardBody>
        <div className="table-responsive table-card">
          <Table className="align-middle table-nowrap mb-4 table-striped">
            <thead className="">
              <tr>
                <th scope="col">Registration Name</th>
                <th scope="col">Registration Type</th>
                <th scope="col">Number</th>
                <th scope="col">Date Registered</th>
                <th scope="col">Length of Validity</th>
                <th scope="col" style={{ width: "150px" }}>
                  Country
                </th>
              </tr>
            </thead>
            <tbody>
              {contractor?.contractorRegistration.map(
                (el: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td>{el.registrationName || "Not Provided"}</td>
                      <td>{el.registrationType || "Not Provided"}</td>
                      <td>{el.registrationNumber || "Not Provided"}</td>
                      <td>
                        {el.registrationDate
                          ? moment(el.registrationDate).format("DD MMM, Y")
                          : "Not Provided"}
                      </td>
                      <td>
                        {el?.lengthOfValidity || "Not Provided"}
                        <RegistrationStatus registration={el} />
                      </td>
                      <td>{tidyCountry(el?.countryOfRegistration) || "Not Provided"}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>

    </Card>
  );
};

export default ContractorRegistration;
